import { Component, OnInit } from '@angular/core';
import { JarwisService } from '../../../services/jarwis.service';
import { SnotifyService } from 'ng-snotify';

@Component({
  selector: 'app-request-reset',
  templateUrl: './request-reset.component.html',
  styleUrls: ['./request-reset.component.scss']
})
export class RequestResetComponent implements OnInit {
  public form = {
    email: null
  };


  constructor(
    private Jarvis: JarwisService,
    private notify: SnotifyService
  ) { }

  ngOnInit() {
  }


  onSubmit() {
    this.notify.info('Attendi...', { timeout: 5000 })
    this.Jarvis.sendPasswordResetLink(this.form).subscribe(
      data => this.handleResponse(data),
      error => this.notify.error("Email non presente nel nostro database")
    );
  }

  handleResponse(res) {
    this.notify.success(res.data, { timeout: 10000 });
    this.form.email = null;
  }

}